import { Epic } from "redux-observable";
import { from, of } from "rxjs";
import { filter, switchMap, map, catchError } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { RootAction } from "../../store/rootAction";
import { RootState } from "../../store/rootReducer";
import { ApiClient } from "../../lib/api";
import { fetchAddressesAsync } from "./actions";

export const fetchAddressesEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  ApiClient
> = (action$, state$, client) =>
  action$.pipe(
    filter(isActionOf(fetchAddressesAsync.request)),
    switchMap(action =>
      from(client.fetchAllAddresses()).pipe(
        map(fetchAddressesAsync.success),
        catchError((error: Error) => of(fetchAddressesAsync.failure(error)))
      )
    )
  );
